/**
 * Sender classification used by backend analytics gating.
 *
 * - typedInput: user typed into chat input
 * - hiddenAutostart: UI/system hidden kickoff message
 * - widgetAction: user click/selection translated into chat text
 * - systemAutomation: backend/system initiated send
 */
export const chatMessageEntrypoint = {
  typedInput: 'typed_input',
  hiddenAutostart: 'hidden_autostart',
  widgetAction: 'widget_action',
  systemAutomation: 'system_automation',
} as const;

export type ChatMessageEntrypoint =
  (typeof chatMessageEntrypoint)[keyof typeof chatMessageEntrypoint];
